<template>
    <div id="share">
        <el-card class="box-card">
            <el-form ref="form"
                     :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'300px'"
                     size="small">
                <el-form-item label="分享标题"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-input v-model="formData.sharetitle"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                </el-form-item>
                <el-form-item label="分享图片">
                    <el-upload
                            class="avatar-uploader"
                            action="upDataUrl"
                            :show-file-list="false"
                            :http-request="myUpload"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="formData.sharepic" :src="formData.sharepic" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="分享描述"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-input v-model="formData.sharedescribe"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    import quillConfig from '../../utils/quill-config.js'
    import {uploadimg} from '../../utils/common'

    export default {
        name: "system_site",
        data() {
            return {
                formData: {
                    sharepic: '',
                    sharetitle: '',
                    sharedescribe: '',
                },
            }
        },
        created() {
            this.getData()
        },
        methods: {
            onSubmit() {
                this.$axios.post('admin/config/share_set', {config: this.formData}).then((res) => {
                    this.$message.success('成功');
                });
            },
            getData() {
                this.$axios.post('admin/config/share', '').then((res) => {
                    this.formData = res.data;
                });
            },
            myUpload(content) {
                uploadimg(content).then(res => {
                    this.formData.sharepic = res;
                })
            },
            beforeAvatarUpload(file) {
                var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
                if (arr.indexOf(suffix) === -1) {
                    this.$message.error('上传图片格式有误');
                    return false
                }
            },
        }
    }
</script>

<style scoped lang="scss">

</style>